export default __webpack_public_path__ + "static/media/Candidates.ab804523.png";